module.exports = __webpack_public_path__ + "static/media/DubaiW23-Regular.f435cc52.woff2";